// Enhance only the native directory search. The server retains visibility and actions.
(function () {
  'use strict';
  function init() {
    var host = document.querySelector('.lxTop_S');
    if (!host || host.dataset.lpSearchObserver) { return; }
    host.dataset.lpSearchObserver = 'true';
    var hr = /^hr/i.test(document.documentElement.lang);
    var t = hr ? {
      title:'Pronađite profile', intro:'Pronađite osobe i tvrtke na Linxpotu.', label:'Ime osobe ili naziv tvrtke',
      placeholder:'Pretraži profile…', hint:'Unesite najmanje 3 znaka.', close:'Zatvori pretragu', clear:'Očisti pretragu',
      start:'Koga tražite?', guidance:'Pretražite po imenu ili nazivu i otvorite profil za više detalja.',
      empty:'Nema pronađenih profila', emptyHelp:'Pokušajte s kraćim imenom ili provjerite pravopis.',
      loading:'Pretraživanje…', error:'Pretraga trenutačno nije dostupna.', retry:'Pokušaj ponovno',
      more:'Prikaži više', shown:'Prikazano profila: ', actions:'Vaše veze'
    } : {
      title:'Find profiles', intro:'Find people and companies on Linxpot.', label:'Person or company name',
      placeholder:'Search profiles…', hint:'Enter at least 3 characters.', close:'Close search', clear:'Clear search',
      start:'Who are you looking for?', guidance:'Search by name, then open a profile to see more.',
      empty:'No profiles found', emptyHelp:'Try a shorter name or check the spelling.',
      loading:'Searching…', error:'Search is unavailable right now.', retry:'Try again',
      more:'Show more', shown:'Profiles shown: ', actions:'Your connections'
    };
    function el(tag, cls, text) {
      var n = document.createElement(tag); n.className = cls;
      if (text) { n.textContent = text; } return n;
    }
    function icon(name) { var n = el('span', 'far fawe-' + name); n.setAttribute('aria-hidden','true'); return n; }
    function button(label, name, action) {
      var n = el('button','t-Button lp-search-icon'); n.type = 'button';
      n.setAttribute('aria-label',label); n.title = label; n.appendChild(icon(name));
      n.addEventListener('click',action); return n;
    }
    function decorate() {
      var menu = host.querySelector('.lxTop');
      if (!menu || menu.dataset.lpSearchReady || !window.lx || !lx.topMenu.search) { return; }
      var body = menu.querySelector(':scope > .content');
      var input = menu.querySelector('#topMenuSearchTerm');
      var results = menu.querySelector('#topMenuSearchResults');
      var oldHeader = menu.querySelector(':scope > .hdr');
      if (!body || !input || !results || !oldHeader) { return; }
      menu.dataset.lpSearchReady = 'true'; menu.classList.add('lp-search-menu');
      menu.setAttribute('role','region'); menu.setAttribute('aria-label',t.title);
      var trigger = host.querySelector('.t-Button--navBar');
      function dismiss() { lx.topMenu.removeClickListener(); if (trigger) { trigger.focus(); } }
      var header = el('header','lp-search-header');
      var titleRow = el('div','lp-search-title-row'); titleRow.appendChild(el('h2','',t.title));
      titleRow.appendChild(button(t.close,'times',dismiss)); header.appendChild(titleRow);
      header.appendChild(el('p','lp-search-intro',t.intro));
      var label = el('label','lp-search-label',t.label); label.htmlFor = input.id; header.appendChild(label);
      var field = el('div','lp-search-field'); field.appendChild(icon('search')); field.appendChild(input);
      input.removeAttribute('onkeyup'); input.removeAttribute('onkeydown'); input.type = 'search';
      input.placeholder = t.placeholder; input.autocomplete = 'off'; input.setAttribute('aria-describedby','lp-search-hint');
      input.setAttribute('aria-controls',results.id);
      var clear = button(t.clear,'times',function () { input.value = ''; schedule(); input.focus(); });
      clear.hidden = !input.value; field.appendChild(clear); header.appendChild(field);
      var hint = el('p','lp-search-hint',t.hint); hint.id = 'lp-search-hint'; header.appendChild(hint);
      menu.insertBefore(header,oldHeader);
      var footer = el('nav','lp-search-actions'); footer.setAttribute('aria-label',t.actions);
      oldHeader.querySelectorAll('.btnContainer > .t-Button').forEach(function (n) {
        n.className = 't-Button lp-search-action'; footer.appendChild(n);
      });
      oldHeader.remove(); body.replaceChildren(results);
      if (footer.children.length) { menu.appendChild(footer); }
      var status = el('div','lp-search-summary'); status.setAttribute('role','status');
      body.prepend(status);
      var timer, revision = 0, busy = false, rows = [], query = '', hasMore = false;
      function state(title, detail, symbol) {
        results.replaceChildren(); var box = el('div','lp-search-state'); box.setAttribute('role','status');
        box.appendChild(icon(symbol)); box.appendChild(el('h3','',title));
        if (detail) { box.appendChild(el('p','',detail)); } results.appendChild(box);
      }
      function render() {
        results.innerHTML = rows.map(function (row) { return lx.topMenu.genSearchRow(row); }).join('');
        status.textContent = t.shown + rows.length;
        if (!rows.length) { state(t.empty,t.emptyHelp,'search'); status.textContent = ''; }
        if (hasMore) {
          var more = el('button','t-Button lp-search-more',t.more); more.type = 'button';
          more.addEventListener('click',function () { request(true); }); results.appendChild(more);
        }
      }
      function request(append) {
        if (busy) { return; }
        var version = revision, term = query; busy = true;
        status.textContent = append ? t.loading : ''; results.setAttribute('aria-busy','true');
        var more = results.querySelector('.lp-search-more'); if (more) { more.disabled = true; }
        apex.server.process('getTopMenuJson',{x01:'S',x02:append ? rows.length : 0,x03:term},{
          dataType:'json',
          success:function (data) {
            if (version !== revision || !menu.isConnected) { return; }
            busy = false; results.removeAttribute('aria-busy');
            rows = append ? rows.concat(data.rows) : data.rows;
            hasMore = data.rows.length >= (data.pageRows || lx.topMenu.search.pageRows || 8);
            lx.topMenu.search.rows = rows; render();
          },
          error:function () {
            if (version !== revision || !menu.isConnected) { return; }
            busy = false; results.removeAttribute('aria-busy'); status.textContent = t.error;
            if (!append) { status.textContent = ''; state(t.error,'','exclamation-circle'); }
            if (more) { more.remove(); }
            var retry = el('button','t-Button lp-search-more',t.retry); retry.type = 'button';
            retry.addEventListener('click',function () { retry.remove(); request(append); }); results.appendChild(retry);
          }
        });
      }
      function schedule() {
        clearTimeout(timer); revision++; busy = false; query = input.value.trim();
        rows = []; hasMore = false; clear.hidden = !input.value;
        results.removeAttribute('aria-busy');
        if (query.length < 3) {
          status.textContent = ''; state(t.start,query ? t.hint : t.guidance,'search'); return;
        }
        status.textContent = ''; state(t.loading,'','search');
        timer = setTimeout(function () { request(false); },300);
      }
      input.addEventListener('input',function (event) { if (!event.isComposing) { schedule(); } });
      input.addEventListener('compositionstart',function () { clearTimeout(timer); });
      input.addEventListener('compositionend',schedule);
      input.addEventListener('keydown',function (event) {
        if (event.key === 'Enter') { event.preventDefault(); clearTimeout(timer); if (query.length >= 3) { request(false); } }
      });
      menu.addEventListener('keydown',function (event) {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dismiss(); }
      });
      var appHeader = document.getElementById('t_Header');
      if (appHeader) {
        var geometry = function () { menu.style.setProperty('--lp-search-top',Math.max(0,appHeader.getBoundingClientRect().bottom) + 'px'); };
        geometry(); var resize = new ResizeObserver(geometry); resize.observe(appHeader);
        var removal = new MutationObserver(function () {
          if (!menu.isConnected) { revision++; clearTimeout(timer); resize.disconnect(); removal.disconnect(); }
        }); removal.observe(host,{childList:true});
      }
      schedule();
    }
    new MutationObserver(decorate).observe(host,{childList:true,subtree:true}); decorate();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded',init); } else { init(); }
})();
